import { axios } from "..";
import { IEmailRecipientFilterGroup } from "../interfaces/models/IEmailDistributionList";

export interface ICalculatedRecipient {
  id: string;
  name: string;
  email: string;
  firmId?: string;
  firm: string;
  country: string;
  region: string[];
}

export interface ICalculateRecipientsRequest {
  recipientFilter: IEmailRecipientFilterGroup;
  templateId?: string;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  pageIndex?: number;
  pageSize?: number;
}

export interface ICalculateRecipientsResponse {
  count: number;
  recipients: ICalculatedRecipient[];
  serverPaginated?: boolean;
  pagination?: {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
  };
}

const EMPTY_RESPONSE: ICalculateRecipientsResponse = {
  count: 0,
  recipients: [],
};

function resolveServerPaginated(
  data: {
    serverPaginated?: boolean;
    count?: number;
    recipients?: unknown[];
    pagination?: { totalCount?: number };
  },
): boolean {
  if (data.serverPaginated === true) {
    return true;
  }

  const recipients = Array.isArray(data.recipients) ? data.recipients : [];
  const totalCount = Number(
    data.pagination?.totalCount ?? data.count ?? recipients.length,
  );

  return totalCount > recipients.length;
}

export const calculateRecipients = async (
  payload: ICalculateRecipientsRequest,
): Promise<ICalculateRecipientsResponse> => {
  try {
    const response = await axios.Post("./emailCalculateRecipients", payload);
    if (!response?.data) {
      return EMPTY_RESPONSE;
    }
    const recipients = Array.isArray(response.data.recipients)
      ? response.data.recipients
      : [];
    return {
      count: Number(
        response.data.pagination?.totalCount ??
          response.data.count ??
          0,
      ),
      recipients,
      serverPaginated: resolveServerPaginated({
        ...response.data,
        recipients,
      }),
      pagination: response.data.pagination,
    };
  } catch (error) {
    return EMPTY_RESPONSE;
  }
};
